import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n)
import zh from './config/zh.js'
import en from './config/en.js'
import es from './config/es.js'
import fr from './config/fr.js'
import ja from './config/ja.js'
import ko from './config/ko.js'
import ru from './config/ru.js'
import th from './config/th.js'
import vi from './config/vi.js'
import ug from './config/ug.js'
import common from '@/common'
import {
    getStorage,
} from '@/util'
const i18n = new VueI18n({
    //设置默认语言
    locale: common.lang,
    //添加多语言
    messages: {
        zh,
        en,
        es,
        fr,
        ja,
        ko,
        ru,
        th,
        vi,
		ug,
    }
})
export default i18n;